import {InView} from "react-intersection-observer";

const FadeSlideIn = (props) => {
    return <InView triggerOnce={true} delay={200} threshold={0.2}>
        {({inView, ref, entry}) => <div ref={ref} className={`${inView ? 'fadeInSlide' : 'opacity-0'}`} {...props}>{props.children}</div>}
    </InView>;
};

export default FadeSlideIn;
